export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/LimitedTimeOffer.ba9b3fc0.svg","height":15,"width":14,"blurWidth":0,"blurHeight":0};